import { Dispatch, SetStateAction } from "react";

import { DirectionEnum, TDrawerCloseFunction, TResolveFn } from "@ryde/shared";

import {
  BookingsProductionDrawerConfiguration,
  BookingsProductionDrawerProducePreview,
} from "./components";

export const bookingsProductionStepsMap = {
  configuration: BookingsProductionDrawerConfiguration,
  producePreview: BookingsProductionDrawerProducePreview,
} as const;

export type BookingsProductionSteps = keyof typeof bookingsProductionStepsMap;
export const DEFAULT_BOOKINGS_PRODUCTION_STEP: BookingsProductionSteps =
  "configuration";

export interface IBookingsProductionStepsComponentProps {
  setCurrentStep: Dispatch<SetStateAction<BookingsProductionSteps>>;
  setHandlers: (args: {
    onCloseHandler: () => void;
    onSaveClick?: () => void;
  }) => void;
  onCloseDrawer: TDrawerCloseFunction;
  setIsSaveDisabled: (isSaveDisabled: boolean) => void;
  setCancelLabel: (label: string) => void;
  setSaveLabel: (label?: string) => void;
  bookingsIds: number[];
  direction?: DirectionEnum;
  isRedirectToProducedRidesAfterProductionFinish?: boolean;
  resolveFn?: TResolveFn;
}
